export enum EFaxStatus {
  PENDING = "Pending",
  QUEUED = "Queued",
  SENDING_FAILED = "SendingFailed",
  RECEIVED = "Received",
  SENT = "Sent",
}
